import React from 'react';
import { Card, CardContent, Typography, Box, useTheme } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useSpendingDistribution } from '../../hooks/useSpendingDistribution';

const COLORS = [
  '#4CAF50', '#2196F3', '#FF9800', '#9C27B0', '#3F51B5', '#E91E63', '#00BCD4', '#FFC107', '#8BC34A', '#FF5722', '#607D8B', '#795548'
];

const SpendingDistributionCard: React.FC = () => {
  const theme = useTheme();
  const { data, isLoading, isError } = useSpendingDistribution();

  return (
    <Card sx={{ height: '100%', backdropFilter: 'blur(20px)', backgroundColor: 'rgba(255, 255, 255, 0.9)', boxShadow: '0px 2px 24px rgba(0, 0, 0, 0.1)', borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ color: theme.palette.text.primary, fontWeight: 500, textAlign: 'center' }}>
          Spending Distribution
        </Typography>
        <Box sx={{ height: 480, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          {isLoading ? (
            <Typography>Loading...</Typography>
          ) : isError ? (
            <Typography color="error">Failed to load spending distribution.</Typography>
          ) : (
            <ResponsiveContainer width={340} height={340}>
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={80}
                  outerRadius={120}
                  paddingAngle={5}
                  dataKey="value"
                  nameKey="name"
                >
                  {data?.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value: number, name: string) => [`${value}%`, name]}
                  contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.9)', borderRadius: 8, border: `1px solid ${theme.palette.divider}`, boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)' }}
                />
                <Legend
                  verticalAlign="bottom"
                  align="center"
                  iconSize={18}
                  height={48}
                  wrapperStyle={{ marginTop: 16 }}
                />
              </PieChart>
            </ResponsiveContainer>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default SpendingDistributionCard; 